import { Component, EventEmitter, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ProjectService } from '../../shared/project/project.service';
import { ConfidenceModel } from '../../shared/project/cards/confidence-model';

export interface RelatedCardsModalData {
    projectId: string;
    viewId: string;
    tabId: string;
    cardIx: number;
    cardsCount?: number;
    confidenceModel?: ConfidenceModel;
    seqMode?: boolean; // the SEQ/TOT switch of /cards, which the modal's cards show and set
}

@Component({
    selector: 'app-related-cards-modal',
    templateUrl: './related-cards-modal.component.html',
    styleUrls: ['./related-cards-modal.component.scss']
})
export class RelatedCardsModalComponent implements OnInit {
    public seqMode: boolean;
    // Switched in the modal: the opener sets its own switch to it
    public seqModeChange = new EventEmitter<boolean>();
    public confidenceModel: ConfidenceModel;
    public dataLoaded: boolean = false;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: RelatedCardsModalData,
        public dialogRef: MatDialogRef<RelatedCardsModalComponent>,
        private projectService: ProjectService
    ) {
        this.seqMode = this.data.seqMode ?? true;
    }

    ngOnInit(): void {
        // Modal always loads fresh data (don't use cached confidenceModel)
        const cardsCount = 4;
        
        this.projectService.getConfidence(
            this.data.viewId, 
            this.data.tabId, 
            this.data.cardIx, 
            cardsCount, 
            null
        )
        .then(result => {
            this.confidenceModel = result;
            this.dataLoaded = true;
            console.log('Confidence result loaded for modal:', result);
        })
        .catch(error => {
            console.error('Error getting confidence:', error);
        });
    }

    onClose(): void {
        this.dialogRef.close();
    }

    onReloadCards(): void {
        // Close the modal and signal parent to reload
        this.dialogRef.close({ shouldReload: true });
    }
    
    onPin(): void {
        // Close the modal and signal parent to explode the card
        this.dialogRef.close({ shouldExplode: true, cardIx: this.data.cardIx });
    }

    onSeqModeChange(seqMode: boolean): void {
        this.seqMode = seqMode;
        this.seqModeChange.emit(seqMode);
    }
}
